import PaymentMethodEditParent from "@/controllers/payment_method/payment-method-edit";

/**
 * Custom Payment Method Edit controller.
 *
 * Extends the parent controller and reuses its entire data flow. The
 * opening balance is a read-only display field on the Edit page, so it
 * is intentionally excluded from the submit payload that the parent
 * update() method builds. This controller only adds a currency-formatting
 * helper for the display field.
 */
export default {
  extends: PaymentMethodEditParent,
};
